import styled from "styled-components";

export const V3EmbedUnavailableWrapper = styled.div`
    width: 100vw;
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px;
`;